import Modal from "~/common/components/Modal";
import { Button, Stack, styled } from "~/common/mui";

import dayjs from "dayjs";
import { Trans, useTranslation } from "react-i18next";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { IMG_STOPWATCH } from "~/utils/url/staticResources";

const Content = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  flex: 1,
  [theme.breakpoints.up("tablet")]: {
    textAlign: "left",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
}));

interface Props {
  isPunchout: boolean;
  onClose: () => void;
  onRefresh: () => void;
  onLogout: () => void;
  timeout: number;
}
export const SessionExpirePopup = ({ isPunchout, onClose, onLogout, onRefresh, timeout }: Props) => {
  const timerStr = dayjs().startOf("day").set("seconds", timeout).format("mm:ss");
  const isMinTablet = useIsMinTabletSize();

  const { t } = useTranslation();

  return (
    <Modal
      onClose={onClose}
      title={t("popup.autologout.title")}
      footerChildren={
        <Stack gap={1} direction={"row"}>
          {!isPunchout && (
            <Button fullWidth={!isMinTablet} variant={"text"} onClick={onLogout}>
              {t("popup.autologout.btn.logout")}
            </Button>
          )}
          <Button fullWidth={!isMinTablet} onClick={onRefresh}>
            {t("popup.autologout.btn.continue")}
          </Button>
        </Stack>
      }
    >
      <Content>
        <Trans i18nKey={"popup.autologout.content.expireTimer"}>
          Your session is about to expire due to inactivity in <b>{{ timerStr }}</b>
        </Trans>

        {!isMinTablet && <img style={{ width: 120 }} src={IMG_STOPWATCH} />}
        <span>
          <Trans i18nKey={"popup.autologout.content.expireAction"}>
            Press <b>Continue session</b> to stay logged in.
          </Trans>
        </span>
      </Content>
    </Modal>
  );
};
